import {assign, Machine} from 'xstate';


const ReprintPalletMachine = Machine({

        id: "reprintPallet",
        context: {
            events: [],
            pallet: null,
            startPalletData: {},
            finishPalletData: {}
        },
        strict: false,
        initial: "init",
        ERROR: {
            target: "error",
            actions: ["logError"]
        },
        states: {
            init: {
                invoke: {
                    src: 'getPalletsForReprint',
                    onDone: {
                        target: 'showPallets',
                        actions: assign({ pallets: (context, event) => event.data })
                    },
                    onError: {
                        target: 'error',
                        actions: assign({ error: (context, event) => event })
                    }
                }
            },
            error: {
                on: {
                    STARTOVER: {
                        target: "init"
                    }
                },
                entry: ['logError'],
            },
            showPallets: {
                on: {
                    SELECTED: {
                        target: "selectPrintOptions",
                        actions: assign({ pallet: (context, event) => event })
                    }
                }
            },
            selectPrintOptions: {
                on: {
                    CONFIRM: {
                        target: "generatingDatasource",
                        actions: assign({ printOptions: (context, event) => event })
                    },
                    BACK: {
                        target: "showPallets",
                    }

                }
            },
            generatingDatasource: {
                invoke: {
                    src: 'generateDataSource',
                    onDone: {
                        target: 'printingManifest',
                        actions: assign({ pallet: (context, event) => event.data })
                    },
                    onError: {
                        target: 'error',
                        actions: assign({ error: (context, event) => {return {errorEventData: event.data}}})
                    }
                }
            },
            printingManifest: {
                invoke: {
                    src: 'printManifest',
                    onDone: {
                        target: 'finished',
                    },
                    onError: {
                        target: 'error',
                        actions: assign({ error: (context, event) => {return {errorEventData: event.data}}})
                    }
                }
            },

            finished: {
                after: {
                    3000: 'init'
                }

            },

        },
    },
);

export default ReprintPalletMachine;